import React from "react";
import styles from "./index.module.scss";

const VERIFIED_STATUSES = ["FT VERIFIED", "BUYER", "REPEAT BUYER"] as const;
type VerifiedStatus = typeof VERIFIED_STATUSES[number];

interface FTTagProps {
  readonly status: string;
  readonly className?: string;
}

export default function FTTag({ status, className }: FTTagProps) {
  const isVerified = VERIFIED_STATUSES.includes(status as VerifiedStatus);
  const displayText = isVerified ? "FT VERIFIED" : status;
  
  return (
    <div className={`${styles.FTVerified} ${styles[status?.replaceAll(" ", "")]} ${className}`}>
      {displayText}
      {isVerified && <img src="/images/single-tick.svg" alt="Verified" />}
      {status === "Onboarded" && <img src="/images/onboarded-tick.svg" alt="Onboarded" />}
    </div>
  );
}
